import ElInputTag from './ElInputTag.vue'

export { ElInputTag }

export default {
    install(Vue) {
        Vue.component('el-input-tag', ElInputTag)
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/el-input-tag/src/index.js
// module id = 2305
// module chunks = 2